import { z } from 'zod';

export const optionalString = z.string()
  .optional()
  .nullable()
  .or(z.literal(''));
